import {
  Button,
  Divider,
  FormControlSizes,
  IconName,
  IndicatorBadge,
  type MixpanelEvent,
  PopperHeader,
  Text,
  useMixpanel,
  VStack,
} from '@talos/kyoko';

interface NotifyTooltipProps {
  title: React.ReactNode;
  tooltip: React.ReactNode;
  close: () => void;
  notifyMixpanelEvent: MixpanelEvent;
}

export function NotifyTooltip({ title, tooltip, close, notifyMixpanelEvent }: NotifyTooltipProps) {
  const mixpanel = useMixpanel();
  return (
    <>
      <PopperHeader
        icon={IconName.BookOpen}
        title={title}
        prefix={<IndicatorBadge>Coming Soon</IndicatorBadge>}
        onCloseClicked={close}
      />
      <VStack gap="spacing8" alignItems="flex-start" w={320} p="spacing8">
        <Text color="colorTextImportant" size="fontSizeDefault">
          {tooltip}
        </Text>
        <Divider w="24px" />
        <Button
          endIcon={IconName.ExternalLink}
          onClick={() => {
            mixpanel.track(notifyMixpanelEvent);
            close();
          }}
          size={FormControlSizes.Small}
        >
          Get Notified
        </Button>
      </VStack>
    </>
  );
}
